import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=657576fa&scoped=true&"
import script from "./answerList.vue?vue&type=script&lang=js&"
export * from "./answerList.vue?vue&type=script&lang=js&"
import style0 from "./answerList.vue?vue&type=style&index=0&id=657576fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657576fa",
  null
  
)

export default component.exports